exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrapper[data-v-d8fff33e]{display:flex;align-items:center;justify-content:center;top:0;left:0;right:0;bottom:0;position:fixed;flex-direction:column;z-index:100;background:hsla(0,0%,100%,.7)}.text[data-v-d8fff33e]{font-weight:600;font-size:20px}", ""]);

